"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFetcherModule = void 0;
var _logger = require("../../../logger");
var _models = require("../../../models");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const getFetcherModule = async (mapType, setIsFetcherModuleLoading, setFetcherModule) => {
  (0, _logger.logDebug)(`getFetcherModule: Loading geocoding search implementation module for map type ${mapType} ...`);
  let promise;
  switch (mapType) {
    case _models.MapProviderType.Bing:
      promise = Promise.resolve().then(() => _interopRequireWildcard(require('../../../utils/bingGeocodingSearch')));
      break;
    case _models.MapProviderType.Yandex:
      promise = Promise.resolve().then(() => _interopRequireWildcard(require('../../../utils/yandexGeocodingSearch')));
      break;
    case _models.MapProviderType.Google:
      promise = Promise.resolve().then(() => _interopRequireWildcard(require('../../../utils/googleGeocodingSearch')));
      break;
    case _models.MapProviderType.Azure:
      promise = Promise.resolve().then(() => _interopRequireWildcard(require('../../../utils/azureGeocodingSearch')));
      break;
    default:
      throw new Error(`getFetcherModule: Wrong map type '${mapType}'.`);
  }
  void promise.then(module => {
    setFetcherModule(module);
    setIsFetcherModuleLoading(false);
  });
  return promise;
};
exports.getFetcherModule = getFetcherModule;